module.exports = __webpack_public_path__ + "static/img/cn.e2750956.svg";